// extracted by mini-css-extract-plugin
export default {"loader-container":"Loader_loader-container__7E2hz","loader-bar":"Loader_loader-bar__7KF4B","progressAnimation":"Loader_progressAnimation__rv8t4"};